/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergencyMessageSelfDeleteV1
 */
export interface EmergencyMessageSelfDeleteV1 {
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageSelfDeleteV1
     */
    emergency_id: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageSelfDeleteV1
     */
    id: string;
}

/**
 * Check if a given object implements the EmergencyMessageSelfDeleteV1 interface.
 */
export function instanceOfEmergencyMessageSelfDeleteV1(value: object): value is EmergencyMessageSelfDeleteV1 {
    if (!('emergency_id' in value) || value['emergency_id'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function EmergencyMessageSelfDeleteV1FromJSON(json: any): EmergencyMessageSelfDeleteV1 {
    return EmergencyMessageSelfDeleteV1FromJSONTyped(json, false);
}

export function EmergencyMessageSelfDeleteV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyMessageSelfDeleteV1 {
    if (json == null) {
        return json;
    }
    return {
        
        'emergency_id': json['emergency_id'],
        'id': json['id'],
    };
}

export function EmergencyMessageSelfDeleteV1ToJSON(json: any): EmergencyMessageSelfDeleteV1 {
    return EmergencyMessageSelfDeleteV1ToJSONTyped(json, false);
}

export function EmergencyMessageSelfDeleteV1ToJSONTyped(value?: EmergencyMessageSelfDeleteV1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emergency_id': value['emergency_id'],
        'id': value['id'],
    };
}

